module.exports = __webpack_public_path__ + "static/img/logo-efunding.e8c0d7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/logo-efunding.svg
// module id = 9LCn
// module chunks = 36